import { useEffect, useState } from 'react'
import { Row, Col, Form, Input, Select, Button, Typography, message } from 'antd'
import { useUser } from '../../hooks/useUser'
import ContentCard from '../../components/layouts/ContentCard'
import DateMaskInput from '../../components/elements/DateMaskInput'
import moment from 'moment'
import { isEmpty, isEqual } from 'lodash'
import { pick } from 'lodash'
import { HelmetHeader } from '../../components/elements/HelmetHeader'
import { track } from '../../utils/analytics'

export default function Profile() {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)
  const { user = {}, updateProfile } = useUser()
  const { setFieldsValue } = form

  useEffect(() => {
    if (!isEmpty(user)) {
      setFieldsValue({
        ...user,
        birthDate: user.birthDate && moment(user.birthDate).format('DD/MM/YYYY'),
      })
    }
  }, [user, setFieldsValue])

  const onSubmit = async (values) => {
    try {
      setIsLoading(true)
      const { birthDate } = values
      const payload = { ...values }

      track({
        event_name: 'form_submit',
        form_name: 'user_info',
        flow: 'main',
        purpose: 'user_info',
      })

      if (birthDate) {
        const date = moment.utc(birthDate, 'DD/MM/YYYY')
        if (date.isValid()) {
          payload.birthDate = date.format()
        }
      }

      if (birthDate === 'dd/mm/yyyy') {
        payload.birthDate = null
      }

      const isChanged = getIsFormFieldsChanged(values)

      if (isChanged) {
        await updateProfile(payload)
        message.success('הפרופיל עודכן בהצלחה')
      }
    } catch (error) {
      message.error(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  const getIsFormFieldsChanged = (values) => {
    const fields = ['firstName', 'lastName', 'gender']
    const isDateChanged = !moment(values.birthDate, 'DD/MM/YYYY').isSame(user.birthDate, 'date')
    return isDateChanged || !isEqual(pick(values, fields), pick(user, fields))
  }

  return (
    <Row justify="center" className="bg bg8">
      <HelmetHeader />
      <Col flex="600px">
        <ContentCard>
          <Row justify="center">
            <Col flex="300px">
              <Typography.Title level={1}>{'פרופיל'}</Typography.Title>

              <Form form={form} layout="vertical" validateTrigger="onSubmit" onFinish={onSubmit}>
                <Form.Item label="אימייל" name="email" style={{ cursor: 'not-allowed' }}>
                  <Input style={{ pointerEvents: 'none' }} />
                </Form.Item>

                <Form.Item label="שם פרטי" name="firstName" rules={[{ required: true }, { max: 20 }]}>
                  <Input />
                </Form.Item>

                <Form.Item label="שם משפחה" name="lastName" rules={[{ required: true }, { max: 20 }]}>
                  <Input />
                </Form.Item>

                <Form.Item label="מין" name="gender">
                  <Select
                    options={[
                      { value: 'male', label: 'זכר' },
                      { value: 'female', label: 'נקבה' },
                      { value: 'other', label: 'אחר' },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  label="תאריך לידה"
                  name="birthDate"
                  rules={[
                    {
                      validator: (_, value) => {
                        const date = moment(value, 'DD/MM/YYYY')
                        const now = moment()

                        if (value && value !== 'dd/mm/yyyy' && (!date.isValid() || date?.isAfter(now))) {
                          return Promise.reject('התאריך אינו תקין')
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <DateMaskInput />
                </Form.Item>

                <br />
                <Button loading={isLoading} htmlType="submit" block shape="round" type="primary">
                  {'שמור'}
                </Button>
              </Form>
            </Col>
          </Row>
        </ContentCard>
      </Col>
    </Row>
  )
}
